import type { FaireProductEntity } from "../../entity_types/product";

export const p_492ug4jmbh: FaireProductEntity = {
  token: "p_492ug4jmbh",
  type: "product",
  name: "Dance Vibes Youth",
  brandToken: "b_4adj9wfm65",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/36615943e6b4aaf19ba42ceb35771f1c1c7570886a9413ba9b8c433a8a0a9158.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.95,
  description: "Dance Vibes Unisex Graphic Kids Tee\n\nShown on White",
  tags: [],
  msrpDollars: 35.89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:22.950Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
